import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { HomeIcon } from "@heroicons/react/24/outline";
import useLanguageDirection from "../../hooks/useLanguageDirection";
import { useLanguageNavigate } from "../../hooks/useLanguageNavigation";

const NavBarMenu = () => {
  const { t } = useTranslation();
  const navigateWithLang = useLanguageNavigate();
  const [openMenu, setOpenMenu] = useState(null);
  const [menuWidths, setMenuWidths] = useState({});
  const menuRef = useRef([]);
  const closeTimeout = useRef(null);
  const direction = useLanguageDirection();
  const menuData = {
    home: {
      name: t("home"),
      path: "/",
      icon: <HomeIcon className="w-5 h-5 lg:h-4 lg:w-4" />,
    },
  };

  const handleMouseEnter = (menuName) => {
    clearTimeout(closeTimeout.current);
    setOpenMenu(menuName);
  };

  const handleMouseLeave = () => {
    closeTimeout.current = setTimeout(() => {
      setOpenMenu(null);
    }, 200);
  };

  const handleClick = (e, path) => {
    e.preventDefault();
    navigateWithLang(path);
  };

  return (
    <div
      className="relative "
      style={{ marginRight: "0PX", marginLeft: "0px" }}
      dir={direction}
    >
      <div className="justify-center gap-5 py-0 lg:py-3 flex lg:flex-row flex-col lg:mt-[5px] my-5 lg:my-0 ">
        {Object.keys(menuData).map((key, index) => (
          <div
            key={key}
            className="relative lg:mb-0 group"
            onMouseEnter={() => handleMouseEnter(menuData[key].name)}
            onMouseLeave={handleMouseLeave}
          >
            <a
              href={menuData[key].path}
              ref={(el) => (menuRef.current[index] = el)}
              className={`flex lg:gap-1 text-white font-medium rounded items-center gap-2 md:text-[15px]
                 ${
                   openMenu === menuData[key].name
                     ? "duration-300 group-hover:text-custom-yellow"
                     : "text-custom-yellow"
                 }
              `}
              onClick={(e) => handleClick(e, menuData[key].path)}
            >
              {menuData[key].icon}
              {menuData[key].name}
            </a>
            <div
              style={{
                width: `${menuWidths[menuData[key].name] || 40}px`,
              }}
              className={`h-[4px] mx-auto hidden lg:block mt-1 duration-300 group-hover:bg-custom-yellow`}
            ></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NavBarMenu;
